import classnames from 'classnames';

import Icon from '../Icon';

import { useModals } from './ModalManagerProvider';
import { ModalProps } from './types';

export type ModalCloseIconProps = Pick<ModalProps, 'onDismiss'> & {
  className?: string;
};

export const ModalCloseIcon: React.FC<ModalCloseIconProps> = ({ className, onDismiss }) => {
  const { closeModal } = useModals();

  const closeHandler = () => {
    onDismiss && onDismiss();
    closeModal();
  };

  return <Icon className={classnames('c-white cursor-pointer', className)} icon="xmark" onClick={closeHandler} size="lg" />;
};
